import React, { useRef } from 'react';

import { VerticalStackLayoutFeatureArea } from '@paragon/contract-library';
import { DistanceField, NumericField } from '@paragon/material';

import { OptionallyNullableFieldWrapper } from '../../../../controls/OptionallyNullableFieldWrapper';

interface Props {
  value: Omit<VerticalStackLayoutFeatureArea, 'guid'>;
  disabled?: boolean;
  onChange: (value: Omit<VerticalStackLayoutFeatureArea, 'guid'>) => void;
}

export function VerticalStackFeatureAreaControls({ value, disabled, onChange }: Props) {
  const bearingWidthRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <OptionallyNullableFieldWrapper
        inputRef={bearingWidthRef}
        property="Bearing Width"
        disabled={disabled}
        value={value.bearingWidth}
        onMadeNull={() => {
          onChange({ ...value, bearingWidth: null });
        }}
      >
        <DistanceField
          inputRef={bearingWidthRef}
          label="Bearing Width"
          disabled={disabled}
          canBeNull
          value={value.bearingWidth}
          onSubmit={(bearingWidth) => {
            onChange({ ...value, bearingWidth });
          }}
        />
      </OptionallyNullableFieldWrapper>

      <NumericField
        label="Number of Verticals"
        disabled={disabled}
        value={value.verticalsCount}
        onSubmit={(verticalsCount) => {
          onChange({ ...value, verticalsCount });
        }}
      />
    </>
  );
}
